import * as tslib_1 from "tslib";
export var log = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (window["_pruLogger"]) {
        return window["_pruLogger"].apply(window, tslib_1.__spread(args));
    }
};
var lt = document.cookie && document.cookie.split("; ");
var ɵ0 = function (row) { return row.indexOf("loggerType") === 0; };
var logty = lt && lt.filter(ɵ0)[0];
var loggerType = logty && logty.split("=")[1];
if (loggerType) {
    window["_pruLogger"] = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        console[loggerType].apply(console, tslib_1.__spread(args));
    };
}
export { ɵ0 };
/**
 * write this in the DevTools console to turn on the log() messages
 *
 window['_pruLogger'] = (...args) => {
   console.log(...args);
   // OR
   console.trace(...args);
 };
 */
/**
 * set a cookie in the DevTools console to turn on the log() messages immediately onload
 *
 document.cookie = "loggerType=log";
 // OR
 document.cookie = "loggerType=trace";
*/
//# sourceMappingURL=log.js.map